import { useTranslateItem } from 'src/hooks/directus/useTranslateItem';
import {
  DictionaryCode,
  DictionaryTitlesCode,
} from 'src/models/pim/dictionaries';
import { useDictionaryDetailsQuery } from 'src/modules/products/hooks/useDictionaryDetailsQuery';

export const useTitlesDictionary = (code: DictionaryTitlesCode | undefined) => {
  const translateFn = useTranslateItem();

  const { data: dictionary } = useDictionaryDetailsQuery(DictionaryCode.Titles);

  return (
    dictionary?.entries
      .filter((entry) => entry.code === code)
      .map(translateFn) ?? []
  );
};
